import { isValidString } from './isValidString'

export const stringHasNumber = (str) => isValidString(str) && /\d/.test(str)
